import { inject, Injectable } from '@angular/core';
import { CreateCarrier, UpdateCarrier } from '../models/carrier.model';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import {
  ApiPaginationResult,
  ApiResult,
} from '../../shared/models/api-result.model';

@Injectable({
  providedIn: 'root',
})
export class CarrierService {
  private http = inject(HttpClient);

  apiBaseUrl = environment.apiBaseUrl;

  getAll(pageNumber: number, pageSize: number, name?: string) {
    let params = '';

    if (name) params += `&name=${name}`;

    return this.http.get<ApiPaginationResult>(
      this.apiBaseUrl +
        `/api/v1/carriers?pageNumber=${pageNumber}&pageSize=${pageSize}${params}`
    );
  }

  getById(id: string) {
    return this.http.get<ApiResult>(this.apiBaseUrl + '/api/v1/carriers/' + id);
  }

  getAllDropdown(name?: string) {
    let params = '';

    if (name) {
      params += `?name=${name}`;
    }
    return this.http.get<ApiResult>(
      this.apiBaseUrl + `/api/v1/carriers/dropdown${params}`
    );
  }

  create(data: CreateCarrier) {
    return this.http.post<ApiResult>(
      this.apiBaseUrl + '/api/v1/carriers',
      data
    );
  }

  update(id: string, data: UpdateCarrier) {
    return this.http.put<ApiResult>(
      this.apiBaseUrl + '/api/v1/carriers/' + id,
      data
    );
  }

  updateStatus(id: string, isActive: boolean) {
    return this.http.patch<ApiResult>(
      this.apiBaseUrl + `/api/v1/carriers/${id}/status`,
      { isActive }
    );
  }
}
